module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name === 'listing') ? _c('div', {
    staticClass: "exclusive-topbar",
    class: _vm.isExclusiveSavingVisible ? 'd-block' : 'd-none',
    style: ([_vm.bannerStyle]),
    attrs: {
      "id": "exclusive-savings-info"
    }
  }, [_c('div', {
    staticClass: "container-fluid p-0"
  }, [(_vm.bannerMsg) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center ml-1 mr-1 pt-1 pb-1"
  }, [_c('span', [_c('span', [_vm._v(_vm._s(_vm.bannerMsg) + " "), (_vm.calculations.exclusive_savings && _vm.bannerMsg.includes('Rs')) ? _c('strong', [_vm._v(_vm._s(parseInt(_vm.calculations.total_savings - _vm.calculations.coupon_discount)))]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeInfoBar
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b1cc7bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ExclusiveSavingInfo.vue
// module id = 901
// module chunks = 117